const SDK_VERSION = '7.120.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
